<template>
  <div class="pc-container" ref="Content">
    <div class="title-container">
      <img src="@/assets/images/cloud_l.png" alt="" />
      <div class="title-text">云游泰康之家</div>
      <img src="@/assets/images/cloud_r.png" alt="" />
    </div>
    <div class="list-container" v-if="initialFlag">
      <div
        class="list-content"
        ref="listContent"
        v-if="lists.length > 0"
        :class="{ empty: lists.length == 0 }"
      >
        <div
          class="list-item"
          v-for="(item, index) in lists"
          :key="index"
          @click="run_720_cloud(item.playAddress)"
          :class="{
            active: currentImageIndex === index && !isHovered,
            hovered: hoveredIndex === index,
          }"
        >
          <div class="image-container">
            <div
              class="aspect-ratio-wrapper"
              :class="{
                active: currentImageIndex === index && !isHovered,
                hovered: hoveredIndex === index,
                out: outIndex === index,
              }"
            >
              <img
                v-if="item.materialName"
                :src="item.thumbnailAddress"
                :class="{
                  active: currentImageIndex === index && !isHovered,
                  hovered: hoveredIndex === index,
                }"
                @mouseover="onMouseOver(index)"
                @mouseout="onMouseOut"
                alt=""
              />
            </div>
          </div>

          <div v-if="item.materialName" class="list-item-bottom">
            <div class="name">{{ item.materialName }}</div>
            <img class="location-img" src="@/assets/images/location.png" />
            <div class="address" v-if="item.cityName">{{ item.cityName }}</div>
          </div>
        </div>
      </div>
      <div class="list-content" v-else>
        <div class="list-item" v-for="item in [1, 2, 3, 4]">
          <div class="image-container">
            <div class="aspect-ratio-wrapper">
              <div class="image-empty">
                <img src="@/assets/images/empty.png" alt="" />
                <div class="image-empty-text">敬请期待</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 布局相关
      showlayout: 0,
      // 组织、专业和类别代码（当前未使用）
      organizationCode: "",
      professionCode: "",
      categoryCode: "",
      // 选项数据（已注释）
      options: [],
      // 加载状态
      loading: false,
      // 分页相关
      pageIndex: 1,
      totalPage: 0,
      // 列表数据
      lists: [],
      // 标签数据
      tab_label: [
        { label: "VR视频", type: "1" },
        { label: "VR图片", type: "2" },
        { label: "社区数字孪生", type: "3" },
        { label: "平面视频", type: "4" },
        { label: "GIF动图", type: "5" },
      ],
      // 当前激活的标签
      activeName: "1",
      // 是否固定顶部
      Fixed: false,
      // 渠道ID
      channelId: "",
      // 当前图片索引
      currentImageIndex: -1,
      // 是否悬停
      isHovered: false,
      // 悬停索引
      hoveredIndex: -1,
      // 移出索引
      outIndex: -1,
      // 动画计时器
      timer: null,
      // 悬停超时计时器
      hoverTimeout: null,
      // 初始标志
      initialFlag: false,
    };
  },
  // 组件挂载后执行
  mounted() {
    this.channelId = this.$route.query.id; // 获取渠道ID
    console.log("pc.vue channelId : ", this.channelId);
    this.downlist(); // 加载数据
    setTimeout(() => {
      if (!this.initialFlag) {
        setTimeout(() => {
          this.currentImageIndex =
            (this.currentImageIndex + 1) % this.lists.length; // 初始化图片索引
        }, 300);
        this.initialFlag = true; // 设置初始标志
      }
      this.startAnimation(); // 开始动画
    }, 500);
  },
  // 组件销毁前执行
  beforeDestroy() {
    this.stopAnimation(); // 停止动画
    clearTimeout(this.hoverTimeout); // 清除悬停超时计时器
  },
  // 监听属性变化
  watch: {
    currentImageIndex(newVal, oldVal) {
      setTimeout(() => {
        this.outIndex = newVal; // 更新移出索引
      }, 1000);
    },
    hoveredIndex(val) {
      setTimeout(() => {
        this.outIndex = val; // 更新移出索引
      }, 1000);
    },
  },
  // 计算属性
  computed: {
    paddedList() {
      const list = [...this.lists]; // 复制列表
      const remainder = list.length % 4; // 计算余数
      if (remainder !== 0) {
        const paddingCount = 4 - remainder; // 计算需要补充的项数
        for (let i = 0; i < paddingCount; i++) {
          list.push({
            materialName: null,
            organizationName: null,
            cityName: null,
            playAddress: null,
            thumbnailAddress: null,
          }); // 补充空白项
        }
      }
      return list; // 返回填充后的列表
    },
  },
  // 方法
  methods: {
    // 滚动到活动卡片
    scrollToActiveCard(index) {
      const cards = this.$el.querySelectorAll(".list-item"); // 获取所有列表项
      if (!cards.length || index < 0 || index >= cards.length) return; // 边界检查
      const card = cards[index]; // 获取目标卡片
      const rect = card.getBoundingClientRect(); // 获取卡片位置
      const isInViewport = rect.top >= 0 && rect.bottom <= window.innerHeight; // 检查卡片是否在视口中
      let offset = 35; // 偏移量
      if (index == 0) {
        offset = 200; // 第一个卡片特殊处理
      }
      if (!isInViewport) {
        const targetTop = rect.top + window.scrollY - offset; // 计算目标位置
        window.scrollTo({
          top: targetTop,
          behavior: "smooth", // 平滑滚动
        });
      }
    },
    // 开始动画
    startAnimation() {
      this.stopAnimation(); // 清除之前的计时器
      this.timer = setInterval(() => {
        if (!this.isHovered) {
          this.currentImageIndex =
            (this.currentImageIndex + 1) % this.lists.length; // 更新图片索引
          this.scrollToActiveCard(this.currentImageIndex); // 滚动到活动卡片
        }
      }, 5000); // 设置计时器间隔
    },
    // 停止动画
    stopAnimation() {
      clearInterval(this.timer); // 清除计时器
    },
    // 鼠标悬停事件
    onMouseOver(index) {
      this.isHovered = true; // 设置悬停状态
      this.hoveredIndex = index; // 设置悬停索引
      this.stopAnimation(); // 停止动画
      clearTimeout(this.hoverTimeout); // 清除悬停超时计时器
      this.hoverTimeout = setTimeout(() => {
        this.currentImageIndex = (this.hoveredIndex + 1) % this.lists.length; // 更新图片索引
        this.hoveredIndex = -1; // 重置悬停索引
        this.isHovered = false; // 重置悬停状态
        this.startAnimation(); // 开始动画
      }, 30000); // 设置悬停超时时间
    },
    // 鼠标移出事件
    onMouseOut() {
      this.isHovered = false; // 重置悬停状态
      clearTimeout(this.hoverTimeout); // 清除悬停超时计时器
      this.hoverTimeout = null; // 重置悬停超时计时器
      if (this.hoveredIndex != -1) {
        this.currentImageIndex = (this.hoveredIndex + 1) % this.lists.length; // 更新图片索引
        this.hoveredIndex = -1; // 重置悬停索引
      }
      this.startAnimation(); // 开始动画
    },
    // 移动显示（未实现）
    moveshow() {
      this.showlayout = 1;
    },
    // 鼠标移出（未实现）
    mouseout() {
      this.showlayout = 0;
    },
    // 运行720云
    run_720_cloud(url) {
      if (!url) return;
      this.$router.push({
        path: "/container",
        query: {
          index: url,
        },
      });
    },
    // 当前页（未实现）
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.list();
    },
    // 切换标签
    tk_tab(type) {
      this.activeName = type;
      this.pageIndex = 1;
      this.categoryCode = type;
      this.list();
    },
    // 加载列表（未实现）
    list() {
      this.loading = true;
      this.list = [];
    },
    // 加载数据
    downlist() {
      if (typeof this.$route.query.id != "undefined") {
        // 链接携带了channelId
        this.$api.getDataByChannelId(this.$route.query.id).then((res) => {
          if (res.data.code == 0) {
            this.lists = res.data.data;
          } else {
            this.lists = [];
            this.$message.error(res.data.message);
          }
        });
      } else {
        // 默认获取云游泰康之家数据
        this.$api.getVisitHomeList().then((res) => {
          if (res.data.code == 0) {
            this.lists = res.data.data;
          } else {
            this.lists = [];
            this.$message.error(res.data.message);
          }
        });
      }
    },
    // 处理滚动事件（未启用）
    handleScroll() {
      const scrolled =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var offsetTop = 100;
      if (scrolled > offsetTop) {
        this.Fixed = true;
      } else {
        this.Fixed = false;
      }
    },
  },
};
</script>
<style scoped lang="less">
.pc-container {
  width: 100%;
  min-height: 100vh;
  background: url(../../assets/images/page_bg.png);
  background-size: contain;

  .title-container {
    display: flex;
    padding-top: 25px;
    align-items: center;
    justify-content: center;

    > img {
      height: 22px;
    }

    .title-text {
      padding: 0 14px;
      font-family: "FZY3JW--GB1";
      font-weight: normal;
      font-size: 30px;
      color: #ff8815;
      line-height: 52px;
    }
  }

  .list-content {
    padding: 0 3.75%;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
    column-gap: 2%;
    margin-top: 24px;

    .list-item {
      margin-bottom: 32px;
      position: relative;
      transition: transform 1s ease-in-out;
    }

    .list-item.active {
      transform: scale(1.05);
      // &::before {
      //   content: '';
      //   position: absolute;
      //   top: 0;
      //   left: 0;
      //   width: 100%;
      //   height: 100%;
      //   background-color: rgba(0, 0, 0, 0.1); /* 半透明黑色 */
      //   pointer-events: none; /* 防止遮罩挡住鼠标事件 */
      //   border-radius: inherit;
      // }
    }

    .list-item.hovered {
      transform: scale(1.05);
      // &::before {
      //   content: '';
      //   position: absolute;
      //   top: 0;
      //   left: 0;
      //   width: 100%;
      //   height: 100%;
      //   background-color: rgba(0, 0, 0, 0.1); /* 半透明黑色 */
      //   pointer-events: none; /* 防止遮罩挡住鼠标事件 */
      //   border-radius: inherit;
      // }
    }

    .box-shadow {
      -webkit-box-shadow: 0 0.25rem 1rem rgba(48, 55, 66, 0.15);
      box-shadow: 0 4px 16px rgba(48, 55, 66, 0.15);
    }
  }
}

.image-container {
}

.image-container .aspect-ratio-wrapper {
  position: relative;
  width: 100%;
  padding-bottom: 75.05%; /* 16:9 的比例换算 (9/16 * 100%) */
  border-radius: 9px;
  overflow: hidden;
  // transition: border-radius 0s ease-in-out 1s;
}

.image-container .aspect-ratio-wrapper.active {
  border-radius: 9px;
}

.image-container .aspect-ratio-wrapper.hovered {
  border-radius: 9px;
}

.image-container .aspect-ratio-wrapper.out {
  transition: border-radius 0s ease-in-out 1s;
}

.image-container img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: transform 1s ease-in-out;
}

.image-container img.active {
  transform: scale(1.5);
}

.image-container img.hovered {
  transform: scale(1.5);
}

.image-container .image-empty {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  img {
    position: absolute;
    top: 9.6%;
    left: 19.9%;
    right: 19.9%;
    width: 60%;
    height: 79.8%;
  }
  .image-empty-text {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 22.36%;
    font-family: PingFangSC, PingFang SC;
    font-weight: 300;
    font-size: 20px;
    text-align: center;
    color: #6e6762;
  }
}

.list-item-bottom {
  margin-top: 16px;
  display: flex;
  align-items: center;

  .name {
    flex: 1;
    font-family: FZY4JW--GB1;
    font-size: 22px;
    color: #271f19;
    line-height: 27px;
  }

  .location-img {
    margin-top: 1px;
    margin-right: 4px;
    width: 16px;
  }

  .address {
    font-family: FZY3JW--GB1;
    font-weight: normal;
    font-size: 20px;
    color: #828282;
    line-height: 23px;
  }
}
</style>
